import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-supervisor-panel',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './supervisor-panel.component.html',
    styleUrl: './supervisor-panel.component.scss'
})
export class SupervisorPanelComponent {
    @Input()
    title = '';

    @Input()
    message = '';

    @Input()
    inverseColors = false;

    @Input()
    showBackButton = false;

    @Output()
    readonly backClicked = new EventEmitter<void>();
}
